import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../types/query-key-enum";
import { getClaimValue, hasClaimsRole } from "../utils/general-helper";
import config from "../config/config";
import { BffUserData, getBffUser } from "../services/api/user-api";

export const useBffUser = () => {
	const {
		data: bffUser,
		isLoading: isLoading,
		status: status,
	} = useQuery<BffUserData>({
		queryKey: [QueryKeys.BffUser],
		queryFn: getBffUser,
		refetchInterval: 1000 * 60 * 5,
		staleTime: 1000 * 60 * 2,
		gcTime: 1000 * 60 * 10,
		retry: 3,
	});

	const impersonateUser = (userSubject: string) => {
		window.location.href = `${config.authorityUrl}/account/impersonate/${userSubject}?returnUrl=${config.appBaseUrl}`;
	};

	const stopImpersonatingUser = () => {
		window.location.href = `${config.authorityUrl}/account/impersonate/stop?returnUrl=${config.appBaseUrl}`;
	};

	const logout = () => {
		if (!logoutUrl) {
			console.error("Logout URL is not available.");
			return;
		}

		window.location.href = logoutUrl;
	};

	const subject = getClaimValue(bffUser, "sub");
	const isSupport = hasClaimsRole(bffUser, "caspeco.support");
	const isDeveloper = hasClaimsRole(bffUser, "caspeco.developer");
	const canImpersonate = hasClaimsRole(bffUser, "caspeco.impersonator");
	const isImpersonating = Boolean(getClaimValue(bffUser, "impersonator_id"));
	const logoutUrl = bffUser
		? (() => {
				const logoutPath = getClaimValue(bffUser, "bff:logout_url");
				if (!logoutPath) return undefined;
				const bffUrl = new URL(config.bffUrl);
				return `${bffUrl.origin}${logoutPath}`;
			})()
		: undefined;

	return {
		bffUser,
		isLoading,
		status,
		subject,
		isSupport,
		isDeveloper,
		canImpersonate,
		isImpersonating,
		impersonateUser,
		stopImpersonatingUser,
		logout,
	};
};
